import { Layout } from "@/components/layout/Layout";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Obrigado = () => {
  return (
    <Layout>
      <section className="min-h-[70vh] flex items-center justify-center py-20">
        <div className="container max-w-2xl text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircle className="h-20 w-20 text-primary" />
          </div>
          <h1 className="text-4xl font-bold text-foreground">
            Obrigado pelo contato!
          </h1>
          <p className="text-lg text-muted-foreground">
            Recebemos suas informações com sucesso. A equipe da Cogni entrará em contato com você em breve.
          </p>
          <div className="pt-4">
            <Button asChild>
              <Link to="/">Voltar para a página inicial</Link>
            </Button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Obrigado;
